<template>
  <div>
    <AccountBalanceTable
      class="account-balance__table"
      :items="pagedItems"
      :headers="headers"
    >
      <template #item.dateRequest="{ item }">
        {{ new Date(item.dateRequest).toLocaleDateString() }}
      </template>

      <template #item.method="{ item }">
        <div class="account-balance__table-action-title">
          <template v-if="item.method === 'card'">
            <BaseSvg name="ico-passport-card" />
            <span class="mr-2">Перевод на карту</span>
          </template>

          <template v-else-if="item.method === 'cash'">
            <BaseSvg name="ico-wallet-2" />
            <span>Наличка</span>
          </template>

          <template v-else>
            <BaseSvg name="ico-question" />
            <span>Какой-то другой способ</span>
          </template>
        </div>
      </template>

      <template #item.status="{ item }">
        <AccountBalanceChip
          v-if="item.status === 'pending'"
          value="Принят в работу"
        />

        <AccountBalanceChip
          v-else-if="item.status === 'process'"
          class="_orange"
          value="Обрабатывается"
        />

        <AccountBalanceChip
          v-else-if="item.status === 'paid'"
          class="_green"
          value="Выплачен"
        />

        <AccountBalanceChip
          v-else
          :value="item.status"
        />
      </template>

      <template #item.datePaid="{ item }">
        <span v-if="item.datePaid">{{ new Date(item.datePaid).toLocaleDateString() }}</span>
        <span v-else>-</span>
      </template>

      <template #item.summa="{ item }">
        <div class="account-balance__table-summa">
          <button
            v-if="item.status === 'paid'"
            class="account-balance__table-repeat base-btn base-btn--outline-grey base-btn--small"
            @click="$emit('repeatTransaction', item)"
          >
            <BaseSvg name="ico-update" />
          </button>

          <AccountBalanceChip
            class="_large _dark-blue"
            money
            :value="item.summa"
          />
        </div>
      </template>
    </AccountBalanceTable>

    <div class="account-balance__footer">
      <div class="account-balance__footer-left">
      </div>

      <div class="account-balance__footer-right">
        <AccountBalanceCashRequestButton/>
      </div>
    </div>
  </div>
</template>

<script>
  import AccountBalanceTable from '@/components/balance/AccountBalanceTable';
  import AccountBalanceChip from '@/components/balance/AccountBalanceChip';
  import AccountBalanceCashRequestButton from '@/components/balance/AccountBalanceCashRequestButton';

  export default {
    name: 'AccountBalanceOutcoming',

    components: {
      AccountBalanceTable,
      AccountBalanceChip,
      AccountBalanceCashRequestButton
    },

    props: ['items'],

    data: () => ({
      page: 0,
      limit: 9,
      headers: [
        { key: 'dateRequest', title: 'Дата запроса', width: '12em' },
        { key: 'method', title: 'Способ выплаты' },
        { key: 'status', title: 'Статус', width: '15em' },
        { key: 'datePaid', title: 'Дата выплаты' },
        { key: 'summa', title: 'Сумма', width: '15em', align: 'right' }
      ]
    }),

    computed: {
      pagedItems() {
        const start = this.page * this.limit;
        const end = (this.page + 1) * this.limit;
        return this.items.slice(start, end);
      }
    }
  };
</script>
